import { LayoutHOC } from 'base/ui/layout/layout';
import createViewHistoryLogIn from './index-old';
import createLoginHistory from './index';

export const createViewHistoryLogInPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createLoginHistory());
};
